import React, { Fragment } from 'react';
import { CopyrightOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import GlobalFooter from '@/components/GlobalFooter';
import moment from 'moment';
import styles from './UserLayout.less';

const { Footer } = Layout;
const links = [
  {
    key: 'Cloudnosys',
    title: 'Cloudnosys',
    href: 'https://cloudnosys.com',
    blankTarget: true,
  },
];

const FooterView = whiteLabel => {
  return (
    <Footer style={{ padding: 0 }}>
      <GlobalFooter
        links={links}
        copyright={
          <Fragment>
            {whiteLabel && whiteLabel.isActive ? (
              <span>
                <CopyrightOutlined style={{ verticalAlign: 'baseline' }} />
                <span className={styles.copyRight}>{whiteLabel.footerText}</span>
                {moment().year()}
              </span>
            ) : (
              <span>
                Copyright <CopyrightOutlined style={{ verticalAlign: 'baseline' }} />
                <span className={styles.year}>{moment().year()}</span>
              </span>
            )}
          </Fragment>
        }
        isWhiteLabel={whiteLabel?.isActive ? true : false}
      />
    </Footer>
  );
};

export default FooterView;
